import React from 'react';
import Bullets from 'slickpay/common/Bullets.component';

import IMG_DOCK from 'assets/slickpay-splash/SlickpayDock.png';
import Badge from 'components/generic/Badge.component';
import ExternalLink from 'components/generic/ExternalLink.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

import CN from './DockFooter.module.scss';

const LINK_DOC = 'https://gettingslick.typeform.com/to/JTVF4Q2c?utm_source=splashscreen';

const DockFooter = () => {
  const { t } = useTranslation();

  const DATA = C([t('slickPay.dockFooter.bullet1'), t('slickPay.dockFooter.bullet2'), t('slickPay.dockFooter.bullet3')]);

  const tax = t('slickPay.dockFooter.vat');

  return (
    <div data-bem="DockFooter" className={CN.column}>
      <div data-bem="DockFooter__col" className={CN.col}>
        <div className={CN.rectangle}>
          <img src={IMG_DOCK} alt="Dock" className={CN.imageDoc} />

          <div className={CN.order}>
            <div className={CN.flex}>
              <strong>
                <CurrencySign value={39.0} />
              </strong>
              {tax && <span>{tax}</span>}
            </div>
          </div>
        </div>
      </div>
      <div data-bem="DockFooter__col" className={CN.col}>
        <div className={CN.badgeContainer}>
          <Badge name={t('slickPay.dockFooter.badge')} variant="fine" />
        </div>
        <h3 data-bem="DockFooter__title" className={CN.title}>
          {t('slickPay.dockFooter.title')}
        </h3>

        <Bullets data={DATA} />
        <div className={CN.linkContainer}>
          <ExternalLink link={LINK_DOC} variant="buttonPrimary" xSpace>
            <div className={CN.link}>{t('slickPay.dockFooter.orderButton')}</div>
          </ExternalLink>
        </div>
      </div>
    </div>
  );
};
export default DockFooter;
